"use client";

import { useEffect, useState } from "react";

import classNames from "@calcom/lib/classNames";
import { getTenantConfig } from "@calcom/lib/tenantConfig";

export default function Logo({
  small,
  icon,
  inline = true,
  className,
  src,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const [logoSrc, setLogoSrc] = useState<string | null>(src ?? null);

  useEffect(() => {
    if (!src) {
      const origin = window.location.origin;
      const tenant = getTenantConfig(origin);
      setLogoSrc(tenant.logo);
    }
  }, [src]);

  const placeholderClass = icon
    ? "mx-auto w-9 h-9"
    : small
    ? "h-8 w-24" // width is approximate, adjust to match your logo proportions
    : "h-12 w-32";

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {logoSrc ? (
          icon ? (
            <img className="mx-auto w-9 dark:invert" alt="Logo" title="Logo" src={logoSrc} />
          ) : (
            <img
              className={classNames(small ? "h-8 w-auto" : "h-12 w-auto", "dark:invert")}
              alt="Logo"
              title="Logo"
              src={logoSrc}
            />
          )
        ) : (
          // Placeholder box
          <div className={classNames("bg-transparent", placeholderClass)} />
        )}
      </strong>
    </h3>
  );
}
